/**
 * How many selectors a threat report covers.
 *
 * A non-empty ``creatorIds`` list is the analyst's selection. An empty list
 * means every account in the export, so the count waits on that list.
 */
export function threatReportSelectorCount(
  creatorIds: readonly string[],
  exportCreators: readonly { creatorId: string }[] | undefined,
): number | null {
  if (creatorIds.length > 0) return creatorIds.length;
  if (!exportCreators) return null;
  return exportCreators.length;
}

export function selectorCountLabel(count: number): string {
  return `${count} ${count === 1 ? 'selector' : 'selectors'}`;
}
